<cui-dialog
  closeButtonLabel="Close Dialog"
  [showClose]="true"
  (close)="onClose()"
  class="modal-dialog"
  data-pgr-id="cvq-note-dialog"
>
  <div mat-dialog-title dialog-header color="primary">CVQ Notes</div>
  <div mat-dialog-content dialog-content class="pb-xs">
    @if (!!errorMessage) {
    <cui-notification-banner type="error">
      {{ errorMessage }}
    </cui-notification-banner>
    }
    <h2 class="my-xxs">{{ data.cvq.description }}</h2>
    @if (cvq$ | async; as cvq) { @if (cvq.notes.length) {
    <hr />
    } @for (note of cvq.notes; track note; let noteIndex = $index) {
    <div [attr.data-pgr-id]="'note' + noteIndex">
      <div class="w-full whitespace-normal mt-xxs font-bold">
        {{ note.authorName }} ({{ note.authorId }})
        <span class="text-grey-700">{{ getNoteDateFormat(note) }}</span>
        <mat-chip-list class="inline-block mx-xxs">
          <mat-chip
            cuiMatChipAccessibility
            [disableRipple]="true"
            [selectable]="false"
            [removable]="false"
          >
            {{ note.category }}
          </mat-chip>
        </mat-chip-list>
      </div>
      <div class="mb-xs">
        @for (noteLine of note.noteText; track noteLine; let noteTextLineNumber
        = $index) {
        <p [class.mt-bl-2]="noteTextLineNumber === 0">
          {{ noteLine }}
        </p>
        }
      </div>
      @if (noteIndex < cvq.notes.length - 1) {
      <hr />
      }
    </div>
    } }
  </div>
</cui-dialog>
